import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "react-dates/lib/css/_datepicker.css";
import { SingleDatePicker } from "react-dates";
import Checkbox from "../../../../../UI/Form/Checkbox";
import useUniqueId from "../../../../../Hooks/useUniqueId";
import PersonService from "../../../../../../Services/Person.service";
import AlertFilters, { getItemEventSearchPieceFromAlertFilterState, } from "./AlertFilters";
import FAIcon from "../../../../../UI/FAIcon/FAIcon";
import ActivityItemTypeService from "../../../../../../Domain/ActivityItemType/ActivityItemType.service";
import NoteFilters, { getItemEventSearchPieceFromNoteFilterState, } from "./NoteFilters";
import AchievementFilter, { getItemEventSearchPieceFromAchievementFilterState, } from "./AchievementFilters";
import SurveyFilters, { getItemEventSearchPieceFromSurveyFilterState, } from "./SurveyFilters";
import TaskFilters, { getItemEventSearchPieceFromTaskFilterState, } from "./TaskFilters";
import MeetingFilters, { getItemEventSearchPieceFromMeetingFilterState, } from "./MeetingFilters";
import { debouncePromise } from "../../../../../../../util/debounce";
import Modal from "../../../../../UI/Modal/Modal";
import { ModalHeaderCloseButton } from "../../../../../UI/Modal/ModalHeader";
import { OkButton } from "../../../../../UI/StandardButtons/StandardButtons";
import Dot from "../../../../../UI/Dot/Dot";
import { StudentActivityFilterStorageService } from "../../../../../../Services/Shared/LocalStorage.service";
import useService from "../../../../../Hooks/useService";
import { AlertInfo } from "../../../../../UI/StandardAlerts/StandardAlerts";
import useHasPermission from "../../../../../Hooks/useHasPermission";
import ListService from "../../../../../../Services/Shared/List.service";
import ActivityService from "../../../../../../Services/Activity.service";
import { permissionNoteSearchPiece } from "../../../StudentFilterUpdateFeedFilters/NoteFilters";
import DeprecatedSelect from "../../../../../UI/DeprecatedSelect/DeprecatedSelect";
import MessageFilters, { getItemEventSearchPieceFromMessageFilterState, } from "./MessageFilters";
import { usePersonTypeInternalName } from "../../../../../Hooks/usePersonType";
import { PipelineMultiSearch, } from "../../../../../Presentational/Pipeline/PipelineSearch";
const initialState = {
    alertFilters: {},
    noteFilters: {},
    achievementFilters: {},
    surveyFilters: {},
    taskFilters: {},
    meetingFilters: {},
    messageFilters: {},
    globalFilters: {
        eventCreators: [],
        startDate: null,
        endDate: null,
        pipelines: [],
    },
};
const getValue = (setState, statePartial) => {
    if (typeof setState === "function") {
        // @ts-expect-error - TS2349 - This expression is not callable.
        return setState(statePartial);
    }
    return setState;
};
const checkboxesDefaultValue = {
    [ActivityItemTypeService.PersonAlertId.toString()]: true,
    [ActivityItemTypeService.PersonAchievementId.toString()]: true,
    [ActivityItemTypeService.MeetingId.toString()]: true,
    [ActivityItemTypeService.NoteId.toString()]: true,
    [ActivityItemTypeService.SurveyId.toString()]: true,
    [ActivityItemTypeService.TaskId.toString()]: true,
    [ActivityItemTypeService.ResourceShareId.toString()]: true,
    [ActivityItemTypeService.AcademicPlanId.toString()]: true,
    [ActivityItemTypeService.TranscriptCourseId.toString()]: true,
    [ActivityItemTypeService.TranscriptCourseAttendance.toString()]: true,
    [ActivityItemTypeService.PersonId.toString()]: true,
    [ActivityItemTypeService.Message.toString()]: true,
    [ActivityItemTypeService.FormSubmissionId.toString()]: true,
};
const FilterBox = ({ personId, onFilter, opportunity }) => {
    var _a, _b, _c;
    const makeId = useUniqueId()[1];
    const [filtersState, setFiltersState] = React.useState(Object.assign(Object.assign({}, initialState), { globalFilters: Object.assign(Object.assign({}, initialState.globalFilters), { pipelines: ((_a = opportunity === null || opportunity === void 0 ? void 0 : opportunity.stage) === null || _a === void 0 ? void 0 : _a.pipeline)
                ? [opportunity.stage.pipeline]
                : initialState.globalFilters.pipelines }) }));
    React.useEffect(() => {
        var _a;
        if ((_a = opportunity === null || opportunity === void 0 ? void 0 : opportunity.stage) === null || _a === void 0 ? void 0 : _a.pipeline) {
            setFiltersState((fs) => (Object.assign(Object.assign({}, fs), { globalFilters: Object.assign(Object.assign({}, fs.globalFilters), { pipelines: [opportunity.stage.pipeline] }) })));
        }
    }, [(_b = opportunity === null || opportunity === void 0 ? void 0 : opportunity.stage) === null || _b === void 0 ? void 0 : _b.pipeline]);
    const [startDateFocused, setStartDateFocused] = React.useState(false);
    const [endDateFocused, setEndDateFocused] = React.useState(false);
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [me, loadMe] = useService(PersonService.me);
    React.useEffect(() => {
        loadMe();
    }, [loadMe]);
    const [filterEnableState, getEnabledFilters] = useService(ActivityService.getEnabledFiltersForContextPerson);
    const personTypeName = usePersonTypeInternalName();
    React.useEffect(() => {
        // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
        getEnabledFilters(personId, personTypeName);
    }, [personId, getEnabledFilters, personTypeName]);
    const canSeeOthersNotes = useHasPermission("CAN_SEE_NOTES_CREATED_BY_OTHERS");
    const options = React.useMemo(() => [
        {
            text: "Alerts",
            id: ActivityItemTypeService.PersonAlertId,
            state: filtersState.alertFilters,
            node: (_jsx(AlertFilters, { search: filtersState.alertFilters, setSearch: (alertFilters) => {
                    setFiltersState((state) => (Object.assign(Object.assign({}, state), { alertFilters: getValue(alertFilters, state.alertFilters) })));
                } })),
        },
        {
            text: "Achievements",
            id: ActivityItemTypeService.PersonAchievementId,
            state: filtersState.achievementFilters,
            node: (_jsx(AchievementFilter, { state: filtersState.achievementFilters, setState: (achievementFilters) => setFiltersState((state) => (Object.assign(Object.assign({}, state), { achievementFilters: getValue(achievementFilters, state.achievementFilters) }))) })),
        },
        {
            text: "Meetings",
            id: ActivityItemTypeService.MeetingId,
            state: filtersState.meetingFilters,
            node: (_jsx(MeetingFilters, { personId: personId, search: filtersState.meetingFilters, setSearch: (meetingFilters) => setFiltersState((state) => (Object.assign(Object.assign({}, state), { meetingFilters: getValue(meetingFilters, state.meetingFilters) }))) })),
        },
        {
            text: "Notes",
            id: ActivityItemTypeService.NoteId,
            state: filtersState.noteFilters,
            node: (_jsx(NoteFilters, { search: filtersState.noteFilters, setSearch: (noteFilters) => setFiltersState((state) => (Object.assign(Object.assign({}, state), { noteFilters: getValue(noteFilters, state.noteFilters) }))) })),
        },
        {
            text: "Surveys",
            id: ActivityItemTypeService.SurveyId,
            state: filtersState.surveyFilters,
            node: (_jsx(SurveyFilters, { personId: personId, search: filtersState.surveyFilters, setSearch: (surveyFilters) => setFiltersState((state) => (Object.assign(Object.assign({}, state), { surveyFilters: getValue(surveyFilters, state.surveyFilters) }))) })),
        },
        {
            text: "Tasks",
            id: ActivityItemTypeService.TaskId,
            state: filtersState.taskFilters,
            node: (_jsx(TaskFilters, { search: filtersState.taskFilters, setSearch: (taskFilters) => setFiltersState((state) => (Object.assign(Object.assign({}, state), { taskFilters: getValue(taskFilters, state.taskFilters) }))) })),
        },
        {
            text: "Messages",
            state: filtersState.messageFilters,
            id: ActivityItemTypeService.Message,
            node: (_jsx(_Fragment, { children: _jsx(MessageFilters, { search: filtersState.messageFilters, setSearch: (messageFilters) => setFiltersState((state) => (Object.assign(Object.assign({}, state), { messageFilters: getValue(messageFilters, state.messageFilters) }))) }) })),
        },
        {
            text: "Forms",
            state: {},
            id: ActivityItemTypeService.FormSubmissionId,
            node: null,
        },
        {
            text: "Resource Shared",
            state: {},
            id: ActivityItemTypeService.ResourceShareId,
            node: null,
        },
        {
            text: "Academic Plan",
            state: {},
            id: ActivityItemTypeService.AcademicPlanId,
            node: null,
        },
        {
            text: "Courses",
            state: {},
            id: ActivityItemTypeService.TranscriptCourseId,
            node: null,
        },
        {
            text: "Attendance",
            state: {},
            id: ActivityItemTypeService.TranscriptCourseAttendance,
            node: null,
        },
        {
            text: "Comments, Followings, Success Team Assignments, Birthdays, Orientation Completions",
            state: {},
            id: ActivityItemTypeService.PersonId,
            node: null,
        },
    ].filter((option) => filterEnableState.data && filterEnableState.data[option.id]), [
        filterEnableState.data,
        filtersState.achievementFilters,
        filtersState.alertFilters,
        filtersState.meetingFilters,
        filtersState.noteFilters,
        filtersState.surveyFilters,
        filtersState.taskFilters,
        filtersState.messageFilters,
        personId,
    ]);
    const numOptionsWithoutNode = options.filter((option) => option.node === null).length;
    const getItemEventSearch = React.useCallback((filters, checkState) => {
        var _a;
        const global = Object.values(checkState).filter((val) => val).length <
            Object.values(checkboxesDefaultValue).length
            ? {
                activityItemTypeIds: Object.keys(checkState)
                    .filter((key) => checkState[key])
                    .map((key) => parseInt(key, 10)),
            }
            : {};
        const typeIdItemEventSearchMapping = {
            [ActivityItemTypeService.PersonAlertId]: getItemEventSearchPieceFromAlertFilterState(filters.alertFilters),
            [ActivityItemTypeService.NoteId]: permissionNoteSearchPiece(getItemEventSearchPieceFromNoteFilterState(filters.noteFilters), { canSeeOthersNotes, currentPersonId: (_a = me.data) === null || _a === void 0 ? void 0 : _a.personId }),
            [ActivityItemTypeService.PersonAchievementId]: getItemEventSearchPieceFromAchievementFilterState(filters.achievementFilters),
            [ActivityItemTypeService.SurveyId]: getItemEventSearchPieceFromSurveyFilterState(filters.surveyFilters),
            [ActivityItemTypeService.TaskId]: getItemEventSearchPieceFromTaskFilterState(filters.taskFilters),
            [ActivityItemTypeService.MeetingId]: getItemEventSearchPieceFromMeetingFilterState(filters.meetingFilters),
            [ActivityItemTypeService.ResourceShareId]: null,
            [ActivityItemTypeService.AcademicPlanId]: null,
            [ActivityItemTypeService.TranscriptCourseId]: null,
            [ActivityItemTypeService.TranscriptCourseAttendance]: null,
            [ActivityItemTypeService.PersonId]: null,
            [ActivityItemTypeService.Message]: getItemEventSearchPieceFromMessageFilterState(filters.messageFilters),
            [ActivityItemTypeService.FormSubmissionId]: null,
        };
        const latestValue = [];
        if (Object.values(typeIdItemEventSearchMapping).some((val) => val != null)) {
            Object.keys(typeIdItemEventSearchMapping).forEach((key) => {
                if (checkState[key]) {
                    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
                    const search = typeIdItemEventSearchMapping[key];
                    if (search) {
                        latestValue.push(search);
                    }
                    else {
                        latestValue.push({
                            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number'.
                            activityItemTypeIds: [key],
                        });
                    }
                }
            });
        }
        return {
            global: Object.assign(Object.assign({}, global), { pipelineIds: filters.globalFilters.pipelines.map((p) => p.id) }),
            latestValue,
            eventCreatedByPeoplePersonIds: filters.globalFilters.eventCreators.map((person) => person.personId),
            eventDateFrom: filters.globalFilters.startDate &&
                filters.globalFilters.startDate.toDate(),
            eventDateTo: filters.globalFilters.endDate &&
                filters.globalFilters.endDate.toDate(),
        };
    }, [canSeeOthersNotes, (_c = me.data) === null || _c === void 0 ? void 0 : _c.personId]);
    const [checkBoxStates, setCheckBoxStates] = React.useState(checkboxesDefaultValue);
    const [loadedFilterFromLocalStorage, setLoadedFilterFromLocalStorage] = React.useState(false);
    React.useEffect(() => {
        var _a;
        if (me.data && filterEnableState.wasSuccessful) {
            // Fetch the checkbox state from local storage, or set it to the default value if it's not in local storage
            const checkboxState = ((_a = StudentActivityFilterStorageService.get(me.data.personId)) === null || _a === void 0 ? void 0 : _a.checkboxes) ||
                checkboxesDefaultValue;
            // Permission these checkboxes
            const permissionedCheckboxState = Object.keys(checkboxState).reduce((state, key) => (Object.assign(Object.assign({}, state), { [key]: filterEnableState.data
                    ? // If we have permission data, set the checkbox to true if they set it to true and have permission to.
                        filterEnableState.data[parseInt(key, 10)] && checkboxState[key]
                    : // otherwise just set it to what it's set to.
                        checkboxState[key] })), {});
            setCheckBoxStates(permissionedCheckboxState);
            setLoadedFilterFromLocalStorage(true);
        }
    }, [
        personId,
        me.data,
        filterEnableState.wasSuccessful,
        filterEnableState.data,
    ]);
    const numCheckBoxesChecked = Object.values(checkBoxStates).filter((checked) => checked).length;
    React.useEffect(() => {
        if (me.data && filterEnableState.wasSuccessful) {
            StudentActivityFilterStorageService.set(me.data.personId, {
                checkboxes: checkBoxStates,
            });
        }
    }, [filterEnableState.wasSuccessful, checkBoxStates, me, personId]);
    React.useEffect(() => {
        if (loadedFilterFromLocalStorage) {
            onFilter(getItemEventSearch(filtersState, checkBoxStates));
        }
    }, [
        checkBoxStates,
        filtersState,
        getItemEventSearch,
        loadedFilterFromLocalStorage,
        onFilter,
    ]);
    const allSelected = React.useMemo(() => options.every((option) => checkBoxStates[option.id.toString()]), [checkBoxStates, options]);
    let itemsLabel = "All Items";
    if (!allSelected) {
        if (numCheckBoxesChecked === 1) {
            itemsLabel = "1 Item";
        }
        else {
            itemsLabel = `${numCheckBoxesChecked} Items`;
        }
    }
    const itemsHasRedDot = React.useMemo(() => options.some((option) => checkBoxStates[option.id.toString()] &&
        Object.values(option.state).some((val) => val != null && val.length !== 0)), [checkBoxStates, options]);
    return (_jsxs("div", { className: "d-flex flex-wrap", children: [_jsxs("button", { className: "btn btn-link mr-1", type: "button", onClick: () => setModalIsOpen(true), children: [itemsLabel, itemsHasRedDot && _jsx(Dot, {}), _jsx(FAIcon, { icon: "chevron-down", className: "ml-1" })] }), _jsx("div", { className: "mr-3", children: _jsxs("div", { className: "dropdown", children: [_jsxs("button", { className: "btn btn-link", type: "button", id: makeId("pipeline-dropdown"), "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false", children: [filtersState.globalFilters.pipelines &&
                                    filtersState.globalFilters.pipelines.length > 0
                                    ? filtersState.globalFilters.pipelines.length
                                    : "", " ", filtersState.globalFilters.pipelines &&
                                    filtersState.globalFilters.pipelines.length === 1
                                    ? "Pipeline"
                                    : "Pipelines", _jsx(FAIcon, { icon: "chevron-down", className: "ml-1" })] }), _jsx("div", { className: "dropdown-menu dropdown-menu-right shadow ", style: { width: 400 }, children: _jsx("form", { children: _jsx("div", { className: "p-3", children: _jsx(PipelineMultiSearch, { value: filtersState.globalFilters.pipelines, 
                                        // @ts-expect-error - TS7006 - Parameter 'pipelines' implicitly has an 'any' type.
                                        onChange: (pipelines) => setFiltersState((fs) => (Object.assign(Object.assign({}, fs), { globalFilters: Object.assign(Object.assign({}, fs.globalFilters), { pipelines }) }))), opportunityIds: opportunity ? [opportunity.id] : undefined }) }) }) })] }) }), _jsx("div", { className: "mr-3", children: _jsxs("div", { className: "dropdown", children: [_jsxs("button", { className: "btn btn-link", type: "button", id: makeId("people-dropdown"), "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false", children: [filtersState.globalFilters.eventCreators &&
                                    filtersState.globalFilters.eventCreators.length > 0
                                    ? filtersState.globalFilters.eventCreators.length
                                    : "", " ", filtersState.globalFilters.eventCreators &&
                                    filtersState.globalFilters.eventCreators.length === 1
                                    ? "Person"
                                    : "People", _jsx(FAIcon, { icon: "chevron-down", className: "ml-1" })] }), _jsx("div", { className: "dropdown-menu dropdown-menu-right shadow", style: { width: 400 }, children: _jsx("form", { children: _jsx("div", { className: "p-3", children: _jsx(DeprecatedSelect.Async, { multi: true, loadOptions: debouncePromise((search) => PersonService.simpleSearch(search).then((results) => ({
                                            options: results,
                                        }))), placeholder: "People", valueKey: "personId", labelKey: "fullName", value: filtersState.globalFilters.eventCreators, onChange: (eventCreators) => setFiltersState((state) => (Object.assign(Object.assign({}, state), { globalFilters: Object.assign(Object.assign({}, state.globalFilters), { eventCreators }) }))) }) }) }) })] }) }), _jsx("div", { className: "d-flex align-items-center", children: _jsxs("div", { className: "d-flex react-date-single-picker-group", children: [_jsx(SingleDatePicker, { showClearDate: true, displayFormat: "M/D/YYYY", numberOfMonths: 1, 
                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                            date: filtersState.globalFilters.startDate, id: makeId("updatedFromDate"), placeholder: "date from", onDateChange: (date) => {
                                if (!date && !filtersState.globalFilters.startDate) {
                                    return date;
                                }
                                setFiltersState((state) => (Object.assign(Object.assign({}, state), { globalFilters: Object.assign(Object.assign({}, state.globalFilters), { startDate: date }) })));
                                const { endDate } = filtersState.globalFilters;
                                if (endDate && !endDate.isAfter(date)) {
                                    setFiltersState((state) => (Object.assign(Object.assign({}, state), { globalFilters: Object.assign(Object.assign({}, state.globalFilters), { endDate: date }) })));
                                }
                                return date;
                            }, focused: startDateFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setStartDateFocused(focused), small: true }), _jsx(SingleDatePicker, { numberOfMonths: 1, displayFormat: "M/D/YYYY", showClearDate: true, 
                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                            date: filtersState.globalFilters.endDate, id: makeId("updatedToDate"), placeholder: "date to", onDateChange: (date) => {
                                if (!date && !filtersState.globalFilters.endDate) {
                                    return date;
                                }
                                setFiltersState((state) => (Object.assign(Object.assign({}, state), { globalFilters: Object.assign(Object.assign({}, state.globalFilters), { endDate: date }) })));
                                const { startDate } = filtersState.globalFilters;
                                if (startDate && startDate.isAfter(date)) {
                                    setFiltersState((state) => (Object.assign(Object.assign({}, state), { globalFilters: Object.assign(Object.assign({}, state.globalFilters), { startDate: date }) })));
                                }
                                return date;
                            }, focused: endDateFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setEndDateFocused(focused), small: true })] }) }), _jsxs(Modal, { isOpen: modalIsOpen, onModalClosed: () => setModalIsOpen(false), size: "xl", appendToBody: true, children: [_jsxs("div", { className: "modal-header pl-4", children: [_jsx(Checkbox, { id: makeId("select-all"), label: "Select All", checked: allSelected, onChange: () => {
                                    setCheckBoxStates(options.reduce((sum, option) => (Object.assign(Object.assign({}, sum), { [option.id]: !allSelected })), {}));
                                } }), _jsx(ModalHeaderCloseButton, { closeModal: () => setModalIsOpen(false) })] }), _jsxs("div", { className: "modal-body p-4", children: [_jsxs("div", { className: "row", children: [options
                                        .slice(0, options.length - numOptionsWithoutNode)
                                        .map((option, index) => (_jsxs("div", { className: "col-12 col-md-6 col-lg-3", children: [_jsx(Checkbox, { className: "d-inline", checked: !!checkBoxStates[option.id.toString()], onChange: (e) => {
                                                    const { checked } = e.target;
                                                    setCheckBoxStates((states) => (Object.assign(Object.assign({}, states), { [option.id]: checked })));
                                                }, id: makeId(option.text), label: _jsxs("span", { children: [_jsx(FAIcon, { icon: ActivityItemTypeService.getIcon(option.id), className: `text-${ActivityItemTypeService.getColor(option.id)}`, fixedWidth: true, addMarginRight: true }), option.text, Object.values(option.state).some((val) => val != null && val.length !== 0) && _jsx(Dot, {})] }) }), option.node && _jsx("div", { className: "p-3", children: option.node })] }, index))), ListService.chunk(options.slice(options.length - numOptionsWithoutNode), 5).map((list, listIndex) => (_jsx("div", { className: "col-12 col-md-6 col-lg-3", children: list.map((option, index) => {
                                            var _a;
                                            return (_jsx("div", { className: "form-group", children: _jsx(Checkbox, { className: "mb-2", 
                                                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                                                    checked: !!checkBoxStates[(_a = option.id) === null || _a === void 0 ? void 0 : _a.toString()], onChange: (e) => {
                                                        const { checked } = e.target;
                                                        setCheckBoxStates((states) => (Object.assign(Object.assign({}, states), { 
                                                            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                                                            [option.id]: checked })));
                                                    }, 
                                                    // @ts-expect-error - TS2349 - This expression is not callable. | TS2571 - Object is of type 'unknown'.
                                                    id: makeId(option.text), label: _jsxs("span", { children: [_jsx(FAIcon, { fixedWidth: true, 
                                                                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                                                                icon: ActivityItemTypeService.getIcon(option.id), className: `text-${ActivityItemTypeService.getColor(
                                                                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                                                                option.id)}`, addMarginRight: true }), option.text] }) }) }, index));
                                        }) }, listIndex)))] }), _jsx(AlertInfo, { message: "The items you select will be remembered for all students", className: "mb-0 mt-4" })] }), _jsx("div", { className: "modal-footer", children: _jsx(OkButton, { onClick: () => setModalIsOpen(false) }) })] })] }));
};
export default FilterBox;
